import React from 'react';
import RadioIndicatorSvg from '../assets/radio-indicator.svg?react';
import RadioIndicatorAccentSvg from '../assets/radio-indicator-accent.svg?react';
import { useAccentBgContext } from '../../accent-bg-context/accent-bg-context';

export const RadioIndicator: React.FC = () => {
  const { isAccentBackground } = useAccentBgContext();
  return isAccentBackground ? <RadioIndicatorAccentSvg /> : <RadioIndicatorSvg />;
};
